import { render, staticRenderFns } from "./c_auxiliary_box.vue?vue&type=template&id=d0bf3db4&scoped=true&"
import script from "./c_auxiliary_box.vue?vue&type=script&lang=js&"
export * from "./c_auxiliary_box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0bf3db4",
  null
  
)

export default component.exports